module.exports = __webpack_public_path__ + "img/524X520.b3f20a5e.jpg";